import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
	MotifButton,
	MotifErrorMessage,
	MotifProgressLoader,
} from "@ey-xd/motif-react";
import { useGetCaseClaimListDataQuery } from "@/services/cases/casesReducer";
import Table from "@/components/Table/table";
import { useColumnDefs } from "./ClaimsColumnDefs";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import { ActiveTabsOrder } from "@/menuData";
import { setDiscardEditMode } from "@/components/Modal/ConfirmationModal/discardchanges";
import { useDispatch } from "react-redux";
import { maxPageSize } from "@/Constant";
const Claim = ({ goToNextTab }: { goToNextTab: () => void }) => {
	const { t } = useTranslation();
	const { caseId } = useParams();
	const navigate = useNavigate();
	const {
		control,
		handleSubmit,
		formState: { errors },
		getValues,
		setValue,
		reset,
		trigger,
		setError,
	} = useFormContext();
	const [isDiscardVisible, setIsDiscardVisible] = useState(false);
	  const dispatch = useDispatch();
	  useEffect(() => {
		dispatch(setDiscardEditMode({ editMode: true }));
		return () => {
		  dispatch(setDiscardEditMode({ editMode: false }));
		};
	  }, [dispatch]);
	const creditorId = getValues("creditorId");
	const creditorName = getValues("creditorName");
	const { data, error, isLoading } = useGetCaseClaimListDataQuery({
		caseId,
		creditorId,
		PageSize: maxPageSize,
	});
	const handleCheckboxChange = (
		value: string,
		claimId: string,
		checked: boolean
	) => {
		setValue("claimItems", []);
		setValue("generateClaimItemIds", []);
		setValue("addedClaimItemIds", []);
		setValue("generatePaymentItems", []);
		if (checked) {
			setValue("claimReferenceId", value);
			setValue("claimId", claimId);
		} else {
			setValue("claimReferenceId", "");
			setValue("claimId", "");
		}
	};
	const columnDefs = useColumnDefs({
		control,
		handleCheckboxChange,
	});
	const onSubmit = async () => {
		if (!data?.results.length || error) {
			setError("claimId", {
				type: "required",
			});
			return;
		}
		const isValid = await trigger(["claimId"]);
		if (isValid) {
			goToNextTab();
			setValue("claimItems", []);
		}
	};
	const handleClaimCancel = () => {
		setIsDiscardVisible(false);
		dispatch(setDiscardEditMode({ editMode: true }));

	};
	const handleClaimReset = (event: any) => {
		event.preventDefault();
		reset();
		navigate(`/case/${caseId}?activeTab=${ActiveTabsOrder.PAYMENT}`);
		setIsDiscardVisible(false);
	};

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<div>
				{error ? (
					<MotifErrorMessage
						style={{
							textAlign: "center",
							display: "block",
							alignItem: "center",
						}}
					>
						{t("global.globalNotifications.wentWrong")}
					</MotifErrorMessage>
				) : isLoading ? (
					<MotifProgressLoader show variant="default" />
				) : (
					<Table
						columnDefs={columnDefs}
						cellRenderers={data?.results}
						TitleComplement={() => <></>}
						title={t("pages.paymentStatus.paymentSetup.claim.title", {
							creditorName: creditorName,
						})}
						description={t(
							"pages.paymentStatus.paymentSetup.claim.description"
						)}
						overlayNoRowsTemplate={t("global.globalNotifications.noRecords")}
					/>
				)}
			</div>
			{errors.claimId && (
				<div className="mar-t-20">
					<MotifErrorMessage>
						{t("pages.paymentStatus.paymentSetup.claim.claimRequired")}
					</MotifErrorMessage>
				</div>
			)}
			<div className="display-flex justify-content-end mar-t-20 button-container sticky-footer">
				<div className="pad-r-10">
					<MotifButton
						type="button"
						variant={"secondary"}
						onClick={() =>{
							dispatch(setDiscardEditMode({ editMode: false }));

							setIsDiscardVisible(true)}}
					>
						{t("global.globalActions.cancel")}
					</MotifButton>
				</div>
				<div>
					<MotifButton variant="primary" type="submit">
						{t("global.globalActions.next")}
					</MotifButton>
				</div>
			</div>
			<ConfirmationModal
				isVisible={isDiscardVisible}
				setIsVisible={setIsDiscardVisible}
				cancelBtnApproveHandler={handleClaimReset}
				cancelBtnRejectHandler={handleClaimCancel}
			/>
		</form>
	);
};
export default Claim;
